import React from "react";
import Nav from "../component/Nav";
import Footer from "../component/Footer";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #fffaf3 0%, #f7f3ff 100%)",
    color: "#2d1b12",
    fontFamily: "Arial, sans-serif",
    padding: "40px 20px 80px",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: "28px",
    boxShadow: "0 25px 80px rgba(93, 60, 30, 0.12)",
    overflow: "hidden",
  },
  hero: {
    background: "linear-gradient(135deg, #ffedd5 0%, #f6d3ff 100%)",
    padding: "20px",
    paddingTop: "40px",
    paddingBottom: "40px",
  },
  heroGrid: {
    display: "flex",
    gap: "28px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  mobileVideo: {
    display: "block",
    width: "300px",
    marginTop: "18px",
  },
  eyebrow: {
    margin: 0,
    color: "#8a4d21",
    fontSize: "13px",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  title: {
    margin: "18px 0 14px",
    fontSize: "clamp(2.5rem, 5vw, 4rem)",
    lineHeight: 1.1,
    color: "#2d1b12",
  },
  subtitle: {
    margin: 0,
    maxWidth: "620px",
    color: "#5a4036",
    fontSize: "1.05rem",
    lineHeight: 1.8,
  },
  heroPoints: {
    display: "flex",
    flexWrap: "wrap",
    gap: "14px",
    marginTop: "22px",
  },
  badge: {
    background: "rgba(255,255,255,0.5)",
    border: "1px solid rgba(120, 72, 30, 0.12)",
    borderRadius: "999px",
    padding: "10px 16px",
    fontSize: "0.92rem",
    color: "#4d3021",
    fontWeight: 600,
  },
  videoCard: {
    background: "#fffdfa",
    borderRadius: "26px",
    border: "1px solid rgba(164, 120, 80, 0.18)",
    padding: "18px",
    boxShadow: "0 18px 40px rgba(128, 85, 42, 0.12)",
    width: "500px",
    maxWidth: "90%",
  },
  video: {
    display: "block",
    width: "100%",
    height: "auto",
    borderRadius: "18px",
    background: "#000",
    maxHeight: "360px",
    objectFit: "cover",
  },
  content: {
    padding: "36px 40px 50px",
  },
  stats: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "18px",
    marginBottom: "34px",
  },
  statCard: {
    background: "#fffaf5",
    border: "1px solid #f1e5d3",
    borderRadius: "18px",
    padding: "22px 18px",
  },
  statNumber: {
    display: "block",
    fontSize: "2rem",
    fontWeight: 700,
    color: "#2d1b12",
    marginBottom: "8px",
  },
  statLabel: {
    margin: 0,
    color: "#5e473a",
    fontSize: "0.95rem",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
    marginTop: "10px",
  },
  card: {
    background: "#fffaf5",
    border: "1px solid #f1e5d3",
    borderRadius: "18px",
    padding: "24px 20px",
  },
  cardTitle: {
    margin: "0 0 10px",
    fontSize: "1.25rem",
    color: "#3f250d",
  },
  text: {
    margin: 0,
    color: "#43352f",
    lineHeight: 1.8,
    fontSize: "1rem",
  },
  highlight: {
    marginTop: "28px",
    background: "#fff8ee",
    border: "1px solid #f1d9b7",
    borderRadius: "16px",
    padding: "22px 20px",
    color: "#4f3528",
  },
  strong: {
    color: "#2d1b12",
    fontWeight: 700,
  },
  mobileOnly: {
    display: "none",
  },
  desktopOnly: {
    display: "block",
  },
  mediaQuery: `@media (max-width: 760px) {
    .about-hero-grid {
      grid-template-columns: 1fr;
    }
    .about-video-card {
      order: 1;
      margin-top: 8px;
    }
    .about-video {
      max-height: 240px;
    }
    .about-desktop-video {
      display: none;
    }
    .about-mobile-video {
      display: block;
    }
  }`,
};

const About = () => {
  return (
    <>
      <Nav />
      <br />
      <br />
      <br />
      <style>{styles.mediaQuery}</style>
      <div style={styles.page}>
        <div style={styles.container}>
          <header style={styles.hero}>
            <div className="about-hero-grid" style={styles.heroGrid}>
              <div>
                <p style={styles.eyebrow}>Our Story</p>
                <h1 style={styles.title}>About Swingwings Books</h1>
                <p style={styles.subtitle}>
                  We believe books should spark wonder, build confidence, and
                  help every child discover a love for reading. Swingwings
                  brings together thoughtfully selected children&apos;s books,
                  family favorites, and library-ready recommendations in one
                  warm and welcoming bookstore.
                </p>
                <div style={styles.heroPoints}>
                  <span style={styles.badge}>Curated titles</span>
                  <span style={styles.badge}>Family-first picks</span>
                  <span style={styles.badge}>School support</span>
                </div>
              </div>

              <div className="about-video-card" style={styles.videoCard}>
                <video
                  className="about-desktop-video about-video"
                  style={styles.video}
                  controls
                  playsInline
                >
                  <source src={require("../public/aboutvid.mp4")} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <video
                  className="about-mobile-video about-video"
                  style={{ ...styles.video, display: "none" }}
                  controls
                  playsInline
                >
                  <source src={require("../public/aboutvid.mp4")} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </header>

          <main style={styles.content}>
            <div style={styles.stats}>
              <div style={styles.statCard}>
                <span style={styles.statNumber}>2000+</span>
                <p style={styles.statLabel}>Books selected for young readers</p>
              </div>
              <div style={styles.statCard}>
                <span style={styles.statNumber}>4.9/5</span>
                <p style={styles.statLabel}>
                  Average family satisfaction rating
                </p>
              </div>
              <div style={styles.statCard}>
                <span style={styles.statNumber}>100%</span>
                <p style={styles.statLabel}>Commitment to joyful learning</p>
              </div>
            </div>

            <div style={styles.grid}>
              <div style={styles.card}>
                <h2 style={styles.cardTitle}>What we do</h2>
                <p style={styles.text}>
                  We curate engaging books for young readers, parents, and
                  schools, focusing on quality stories, colorful illustrations,
                  and age-appropriate learning experiences.
                </p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.cardTitle}>Why families choose us</h2>
                <p style={styles.text}>
                  From first picture books to growing chapter-book readers, our
                  selections are designed to make reading joyful, meaningful,
                  and easy to enjoy at home.
                </p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.cardTitle}>Our mission</h2>
                <p style={styles.text}>
                  We aim to support literacy, imagination, and discovery by
                  creating a bookstore that feels warm, trusted, and inspiring
                  for every reader.
                </p>
              </div>
            </div>

            <div style={styles.highlight}>
              <p style={styles.text}>
                At <span style={styles.strong}>Swingwings</span>, we are more
                than a bookstore — we are a reading partner for homes,
                classrooms, and growing minds. Every title we carry is chosen
                with care to help children learn, imagine, and thrive.
              </p>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
